export const routes = {
    emp_session_maintained: 'employee/employee/update_session',

    applicant: {
        applicant_register: 'employee/applicant',
        applicant_login: 'employee/applicant/login',
        create_password: 'employee/applicant/password',
        applicant_create_password: '/employee/forgetPassword/',
        applicant_forget_Link: '/employee/forgetPassword/',
        step1: 'employee/applicant/step/1',
        step2: 'employee/applicant/step/2',
        step3: 'employee/applicant/step/3',
        step3Ssn: 'employee/applicant/ssn',
        step3Forms: 'employee/applicant/form/',
        submitStep4: 'employee/applicant/step/4',
        retreiveForm: '/employee/applicant/retreiveform/',
        applicant_confirm_id: 'employee/forgetPassword/'

    },
    employee: {
        updateHardwareRow: "employee/hardware/master/log/",
        employee_Dob: "employee/hr/employee/dateOfBirth/",
        deleteDocument: "employee/hr/file",
        employee_login: 'employee/employee/login',
        changePassword: "employee/employee/applicant/reset-password",
        getProfilePic: 'employee/employee/profile_pic',
        setProfilePic: 'employee/employee/profile_pic',
        get_employee_all_certificates: 'employee/certificate/employee/',
        get_Audit_view: 'employee/testing-audit/',
        downlaod_auditPdf: 'employee/testing-audit/pdf/',
        get_employee_list: 'employee/hr/employee',
        get_employee_listing_not_Terminated: 'employee/hr/employee/notTerminated',
        AssignTo: '/employee/contractorMaster/EmpCont',
        ContractorTo: '/employee/contractorMaster/listing',
        get_department_list: 'employee/department',
        get_ticket_type_list: 'employee/ticket/type',
        getAllPayroll: 'employee/payrollApprovals',
        createPayroll: 'employee/payrollApprovals',
        get_ticket_category_by_type: 'employee/ticket/type/category/',
        create_ticket: 'employee/ticket',
        department_contact_list: 'employee/departmentContact/',
        job_category_list: 'employee/jobCategory',
        site_list: 'employee/location',
        locomotive_equip: 'employee/locomotive',
        locomotive_equipStatus: '/employee/locomotive/status',
        create_test_event: 'employee/testEvent/1',
        get_test_event_list: 'employee/testEvent',
        get_test_event_list_dashboard: 'employee/testEvent/crew',
        get_test_event_by_id: 'employee/testEvent/',
        get_rules_list: 'employee/testEventRule/rules',
        create_test_event_rule: 'employee/testEventRule',
        view_test_event_rule: 'employee/testEventRuleResult/',
        view_test_event_rule_dashboard: 'employee/testEventRuleResult/crew/',
        departments_list: 'employee/department/',
        all_subdepartments: 'employee/department/sub',
        getForeman: 'employee/employee/non-executive',
        add_certificate: 'employee/certificate',
        update_certificate: 'employee/certificate/',
        get_crew_user_list: 'employee/employee/crew',
        get_Template: 'employee/testing-audit/templates',

        get_employee_AssignTo_listing_not_Terminated: 'employee/employee/WOAssignTo',
        get_assisting_member_list: 'employee/employee/assisting',
        employee_logout: 'employee/employee/logout/',
        Applicant_logout: 'employee/applicant/logout/',

        update_ssn: 'employee/hr/employee/ssn/',
        onUpdateUID: 'employee/hr/employee/uid/',
        search_applicants: 'employee/hr/search/applicant',
        add_hardware: 'employee/hardware/assignedhardware/',
        EditHardware: 'employee/hardware/assignedhardware/',
        getHardwareNames: 'employee/hardware/',
        checkride_fields: 'employee/checkRide/questions',
        incident_fields: 'employee/incident/getIncidents',
        AuditTable: '/employee/testing-audit/list',
        incident_fieldsByID: 'employee/incident',
        EmployeeHardware: 'employee/hardware/master/assignments',
        getRolesPayroll: 'employee/payrollApprovals/users',
        getalltable: 'employee/testing-audit',
        sendAudit: '/employee/testing-audit'




    },
    it: {
        list_it_request: 'employee/ITRequest',
        get_it_request: 'employee/ITRequest/',
        update_it_request: 'employee/ITRequest/',
    },
    hr: {
        EditHowDidYouHere: 'employee/hr/questionnaire/',
        get_applicant: 'employee/hr/applicant',
        get_employee: 'employee/hr/employee',
        get_rejected_reason: "employee/hr/step/reject",
        get_applicant_by_id: 'employee/hr/applicant/',
        updateApplicant: 'employee/hr/applicant/',

        get_applicant_by_id_applicant_login: 'employee/applicant/',
        get_applicants_by_name: 'employee/hr/search/employee',
        step1: 'employee/hr/step/0/approve',
        step2: 'employee/hr/step/1/approve',
        reject: 'employee/hr/step/reject',
        get_tickets_and_allerts: 'employee/ticket',
        list_tickets_and_alerts_by_category: 'employee/ticket/category/',
        get_ticket_by_id: 'employee/ticket/',
        update_tickets: 'employee/ticket/',
        get_employee_by_id: 'employee/hr/employee/',
        update_employee_address: 'employee/hr/employee',
        employee: "employee/hr/applicant/employee/",
        incident_type: 'employee/incidentType/list',
        incident_update: 'employee/incident/update',
        reopen_incident: 'employee/incident/reopen',
        finalize_incident: 'employee/incident/approve',
        classification: 'employee/classification',
        create_updateIncident: 'employee/incident/create',
        //files
        additional_files_uplaod: 'employee/hr/add_files/',
        additional_files_uplaod_emp: 'employee/hr/add_file_emp/',
        additional_files_uplaod_incident: 'employee/incident/add_files/',
        close_applicant: "employee/hr/close-applicant/",
        get_certificate: 'employee/certificate/employee/',
        get_certificate_type: 'employee/certificate/type',
        update_position: 'employee/hr/employee/position',
        update_position: 'employee/hr/employee/position',
        edit_position: 'employee/hr/employee/position/',
        update_Contact: 'employee/hr/Contact/',
        update_List: 'employee/hr/status',
        compcode_List: '/employee/hr/comp_code',
        payCode_List: '/employee/hr/pay_code',
        onUpdate_RehireModal: 'employee/hr//rehire/',
        update_pay: 'employee/hr/employee/pay',
        edit_pay: 'employee/hr/employee/pay/',
        terminate: 'employee/hr/employee/terminate',
        onUpdate_statusModal: 'employee/hr//status/',
        onUpdateNotification: '/employee/ticket/count/',
        onUpdateNewHireQueCount: 'employee/ITRequest/count',

        // dropdowns 
        position_level: 'employee/level/',
        get_job_categories: 'employee/jobCategory',
        department: 'employee/department',
        location: '/employee/location',
        paytype: 'employee/payType',
        subDepartment: 'employee/department/subDepartment/',
        update_emergency_contact: 'employee/hr/EmergencyContact/',
        update_emergency_contact_admin: 'employee/employee/EmergencyContact/',
        //hardware
        get_hardware_type: 'employee/hardware/type',
        get_hardware_Name: 'employee/hardware/manufacturer',
        get_employee_data: 'employee/hardware/assignedhardware/',
        update_Hire_Date: 'employee/hr/hiredate/',
        update_Edit_Terminate_Api: 'employee/hr/employee/terminate',
        add_hardware: 'employee/hardware/master',
    },
    broadcast: {
        create: 'employee/broadcastMessage/',
        getAllSend: 'employee/broadcastMessage/send',
        getAll: 'employee/broadcastMessage/recieve',
        unRead: 'employee/broadcastMessage/all/broadcast',
    },
    checkride: {
        create: '/employee/checkRide/',
        checkride_table: 'employee/checkRide',
        checkride_table_id: 'employee/checkRide/',

        CheckRidePdf: 'employee/checkRidePdf',
        DownloadExportCheckRide: '/employee/checkRide/pdf/',
        DownloadMaintenanceHistory: '/employee/locomotive/maintainceHistory/',
        DownloadDatasheet: '/employee/locomotive/DataSheet/pdf/',
    },
    testEvent: {
        event_type: '/employee/testEvent/safety/',
        AssignedTo: '/employee/contractorMaster/EmpCont',
        job_id: '/employee/testEvent/type'
    },
    hardware: {
        data: 'employee/hardware/master',
        edit: 'employee/hardware/master/',
        getAttributeData: "/employee/hardware/attribute1"
    },
    AuditTab: {
        AuditView: 'employee/AuditView',

    },
    // -------------------------->Locomotive api routes
    Locomotive: {
        TableLocation: '/employee/location/filter',
        getWorkOrderTable: '/employee/equipWOTask',
        lastTastCompleted: '/employee/equipWOTask/last-complete',
        EnterByTask: '/employee/equipWOTask/CauseCode',
        partSubmitApi: '/employee/equipWOTask/task',
        Saveapi: "/employee/equipWOTask/task",
        createLocomotive: "employee/locomotive/create",
        updateLocomotive: 'employee/locomotive/update',
        getAllLocomotive: "/employee/locomotive",
        getTicketCategory: "/employee/ticketCategory",
        getLocomotiveById: "/employee/locomotive",
        LastFedralTable: '/employee/locomotive/federal_inspection',
        updateEquipId: "/employee/locomotive/update/EquipUID",
        updateEquipLocation: "/employee/locomotive/update/EquipLocation",
        updateEquipStatus: "/employee/locomotive/update/EquipStatus",
        getAllStatus: "/employee/equipStatusDD",
        exportLocomotive: "/employee/locomotive/export",
        exportTicketLocomotive: "employee/ticket/category/export/",
        WoOrdersExport: "employee/equipWorkOrder/export",
        exportAuditTab: 'employee/testing-audit/export-csv',
        getDatasheetData: 'employee/locomotive/dataSheet',
        getDatasheetTableData: 'employee/locomotive/dataSheet',
        inspection: "employee/locomotive/inspection_history",
        oos_inspection: "employee/locomotive/oos_history",
        oos_codes: "/employee/locomotive/oos_codes",
        editOOSHistory: "/employee/locomotive/oos_history",
        equipmentExportLocomotive: '/employee/locomotive/equipment/export',
        getAllNotes: "/employee/equipNotes",
        getAllNotesWorkOrder: "/employee/equipWoNotes",
        equipWOCategory: 'employee/equipWOCategory',
        createCategory: 'employee/admin/wo-category/create',
        CreatesubCategory: 'employee/admin/wo-sub-category/create',
        equipWOSubCategory: '/employee/equipWOSubCategory',
        AddWoForm: '/employee/admin/EquipTask',
        TicketFormApi: '/employee/admin/TicketCategory',
        equipWOTaskCategory: '/employee/equipWOTaskDD',
        equipWOPositonCategory: '/employee/equipWOTaskDD/positionType',
        ticketSource: "/employee/ticketSource",
        createNote: "/employee/equipNotes/create",
        notTerminatedEmployeesWRTDept: "employee/employee/department",
        WorkOrderNotes: "/employee/equipWoNotes/create",
        CloseCompleteWo: "/employee/equipWorkOrder/close",
        workOrders: "/employee/locomotive/workorders",
        updateFra: "/employee/locomotive/update/",
        // -----> Contacts API 
        getAllContactList: "/employee/equipCustContact",
        createContact: "/employee/equipCustContact/create",
        // Post API
        deleteContact: "/employee/equipCustContact/delete/",
        createLease: "/employee/equipLeaseHistory/create",
        getCust: "/employee/custMaster",
        getAllLease: "/employee/equipLeaseHistory",
        getAllWorkOrderOpen: 'employee/equipWorkOrder/wo',
        ticketCloseOutReason: "/employee/ticketCloseDD",
        updateLocomotiveTicket: "/employee/ticket/",
        updateLocomotiveTicketModalData: "/employee/ticket/update/",
        updateTicketCategory: 'employee/locomotive/update/category/',
        getEquipmentLookup: "/employee/locomotive/listing/new",
        getAllLocations: "/employee/location/filter",
        getAllWorkOrders: "employee/equipWorkOrder",
        getDatePicker: 'employee/equipWorkOrder/workCompleted/',
        getDatePickerUpdated: '/employee/equipWorkOrder/workScheduled',
        workCompletedTable: 'employee/equipWorkOrder/workCompleted/pdf',
        allInspections: "employee/EquipInspectionHistory/inspections",
        workCompletedTableExport: 'employee/equipWorkOrder/workScheduled/pdf',
        updateStatus: "employee/equipWorkOrder/complete",
        updateApproval: 'employee/locomotive/locoStatus',
        allEquipInspectionHistory: "employee/EquipInspectionHistory/equip-inspections",
        exportEquipInspectionHistory: 'employee/EquipInspectionHistory/export',
        getWorkOrderById: "employee/equipWorkOrder",
        HistoryTable: "employee/locomotive/report",
        updateWorkOrder: "employee/equipWorkOrder",
        DownloadPdfLocomotive: "employee/equipWorkOrder/pdf/",
        DropDownApi: '/employee/EquipWOCauseDD',
        TableWoDelete: 'employee/equipWOTask/deleted',
        TableDataDays: 'employee/equipWOTask/deleted',
        TableDataFilterSheet: 'employee/equipWOTask/export/deleted',


    },

    fuel_management: {
        contractorMaster: "employee/contractorMaster/listing",
        fuelTankMaster: "employee/fuelTankMaster",
        fuelTankMasterUnique: "employee/fuelTankMaster/unique",
        fuel_tank_event: "employee/fuelTankMaster/event",
        fuel_tank_reading: "employee/fuelTankMaster/reading",
        fuel_management_locomotive: "employee/equipWOTask/equipWOTaskHists",
        crtDate_update: "/employee/equipWOTask/CrtDate",
        calulate_gallons_amt: "employee/fuelTankMaster/calculate-gallons"
    },

    Payroll: {
        tickets: 'employee/payroll',
        ticket: 'employee/payroll/',
        pending_tickets: 'employee/payroll/approval-pending',
        approve_ticket: 'employee/payroll/approve/',
        close_ticket: 'employee/payroll/close/',
    }
}
